<template>
    <base-dialog :loading="loading" :value="dialog" :title="$t('admin.invite_coach')" :width="440" @input="onInput" @close="hide">
        <v-form v-model="valid">
            <div class="form-group">
                <span class="form-label">{{ $t('entrance.email') }}</span>
                <kimsa-text-field ref="email" :rules="emailRules" :placeholder="$t('entrance.email')"
                    input-mode="email" @change="email = $event" dense />
            </div>

            <v-alert v-if="errorMessage" text type="error" class="mt-3 mb-0">
                {{ errorMessage }}
            </v-alert>

            <template v-if="needChangePlan">
                <v-alert v-if="!paymentsEnabled" text color="accent" class="mt-3 mb-0">
                    {{ $t('payment.change_plan_from_desktop') }}
                </v-alert>
                <v-btn v-else @click="toChangePlan" color="primary" class="black--text mt-3" block depressed>
                    {{ $t('coach.update_plan') }}
                </v-btn>
            </template>
        </v-form>

        <template v-slot:footer>
            <dialog-actions :confirm-label="$t('common.send')" :disabled="!valid" :loading="loading" @cancel="hide"
                @confirm="confirmInvitation" />
        </template>
    </base-dialog>
</template>

<script>
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import firebase, { db } from "@/utils/Firebase";
import BaseDialog from "@/components/common/BaseDialog";
import DialogActions from "@/components/common/DialogActions";

export default {
    name: "InviteCoachDialog",
    components: { KimsaTextField, BaseDialog, DialogActions },
    data(vm) {
        return {
            dialog: false,
            valid: false,
            email: '',
            errorMessage: '',
            loading: false,
            needChangePlan: false,
            emailRules: [
                v => !!v || vm.$t('rules.required'),
                v => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(v) || vm.$t('rules.invalid_email')
                }
            ],
        }
    },
    computed: {
        priceId(vm = this) {
            return vm.account.stripeAccount && vm.account.stripeAccount.currentSubscription && vm.account.stripeAccount.currentSubscription.priceId || null
        }
    },
    methods: {
        show() {
            this.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        onInput(val) {
            if (!val) this.hide()
        },
        reset() {
            const vm = this
            vm.valid = false
            vm.email = ''
            if (vm.$refs.email) vm.$refs.email.reset()
            vm.errorMessage = ''
            vm.loading = false
            vm.needChangePlan = false
        },
        inviteNewUser: firebase.functions().httpsCallable('httpInvitations-inviteCoach'),
        async confirmInvitation() {
            const vm = this
            if (!vm.email || vm.loading) return
            if (vm.currentUser.email === vm.email) return vm.errorMessage = vm.$t('coach.student_email_cant_be_same_than_yours')
            if (!vm.priceId) return vm.errorMessage = vm.$t('coach.subscription_problem')

            vm.loading = true

            const planRef = await db.collection('plans').where('priceId', '==', vm.priceId).get()
            if (planRef.docs.length > 0) {
                const plan = planRef.docs[0].data()
                const maxCoaches = plan.maxCoaches
                if (Number.isFinite(maxCoaches) && maxCoaches > 0) {
                    const coachesRef = await db.collection('users')
                        .where('coachSubscription.companyId', '==', vm.currentUser.uid).get()
                    if (coachesRef.docs.length >= maxCoaches) {
                        vm.needChangePlan = true
                        vm.loading = false
                        return vm.errorMessage = vm.$t('coach.limit_coaches', { num: maxCoaches })
                    }
                }
            }

            const userRef = await db.collection('users')
                .where('email', '==', vm.email)
                .get()

            if (userRef.docs.length > 0) {
                vm.loading = false
                return vm.errorMessage = vm.$t('admin.this_email_already_used')
            }

            const payload = { email: vm.email }

            vm.inviteNewUser(payload).then(result => {
                console.log('invite student result', result)
                const { data: response } = result
                vm.toast(vm.$t('coach.student_invitation_sent'))
                vm.hide()
            }).catch(err => {
                vm.toast(`${err.message}.` || vm.$t('coach.student_invitation_failed'), 'error')
            }).finally(() => {
                vm.loading = false
            });
        },
        toChangePlan() {
            const vm = this
            vm.hide()
            vm.pushRoute({ name: `${vm.accountType}.profile.edit`, params: { mode: 'SelectPlan' } })
        },
    },
}
</script>

<style scoped>
.form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.form-label {
    font-size: var(--fs-label);
    font-weight: 500;
    color: var(--v-txtSecondary-base);
}
</style>